import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTypeSectionsFetchFailedAction = {
	type: 'DOCUMENT_TYPE_SECTIONS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTypeSectionsFetchFailedAction => ({
	type: 'DOCUMENT_TYPE_SECTIONS_FETCH_FAILED',
	payload,
});
